<template>
  <div :class="{hello,'copyhello':move, 'pb': fs}">
    <div v-show="!move && !fs" style="height: 100%;" class="begin">
      <div v-if="isSearch" id="search" class="yp-topbar">
        <form action="" onsubmit="return false">
          <!--<input type="text" placeholder="搜索" @keyup="serchContent()" v-model="value" @focus="focusInput()"-->
                 <!--@blur="blurInput()">-->
          <input type="text" placeholder="搜索"  v-model="value" @focus="focusInput()"
                 @blur="blurInput()">
          <i class="iconfont icon-sousuo sousuo"></i>
          <i class="iconfont icon-guanbi1 guangbi" v-show="isClose" @click="clear(value)"></i>
          <span @click="cancelSearch()">取消</span>
          <span class="iconfont icon-sousuo search-list" @click="serchContent()"></span>
        </form>
      </div>
      <div class="head yp-topbar" id="head" v-else>
        <ul class="clearfix">
          <input type="button" v-model="check" class="btn fl" @click="checkAll" v-show="isA">
          <input type="button" value="取消" class="btn fr" @click="cancel" v-show="isA">
          <span class="back fl" @click="back" v-show="parentId.length && !isA>0"></span>
          <!--<aaa></aaa>-->
          <li><span id="title">{{index}}</span></li>
          <li @click="checkMobile" v-show="!isA" class="check-mobile"></li>
          <li @click="sheetVisible? sheetVisible=false:sheetVisible=true" v-show="!isA" class="open-mobile"></li>
        </ul>
        <div v-show="sheetVisible" :class="{'pullUp': sheetVisible}" id="selectDown">
          <div @click="prompt">
            <i class="iconfont icon-xinjianwenjianjia"></i>
            <span>新建文件夹</span>
          </div>
          <div v-if="isCanUpload" style="position: relative" @click="test">
            <i class="iconfont icon-shangchuanwenjian"></i>
            上传
          </div>
        </div>
        <div class="v-model" style="top: 1.28rem;" v-if="sheetVisible" @click="sheetVisible=false;"></div>
      </div>
      <div class="search" @click="search()" v-show="!isSearch">
        <input type="text" placeholder="搜索">
        <i class="iconfont icon-sousuo"></i>
      </div>
      <div v-if="hello.length===0" class="jpg" v-cloak>
        <div>
          <img src="../../assets/images/null.png" alt="">
          <p ref="dis">您还没上传过文件/文件夹～</p>
        </div>
      </div>
      <ul :class="{ulcontent: isIphoneX}" class="ulBox" ref="ulBox" v-else
          infinite-scroll-distance="30" infinite-scroll-immediate-check="false"
          v-infinite-scroll="loadMore" infinite-scroll-disabled="true">
        <li v-for="(item,index) in hello">
          <div class="list">
            <em class="check" :class="{'checked': item.ischecked}" @click="checked(index)" ref="mybox" v-show="isA"
                :fileId="item.id"></em>
            <span v-if="slicetype(item.fileName,item.isDir,item.permissionType)!=='icon-package'">
               <i :class="item.fileName | sliceType(item.isDir, item.permissionType)" class="iconfont"></i>
            </span>
            <svg class="icon" aria-hidden="true" v-else>
              <use xlink:href="#icon-package"></use>
            </svg>
            <div class="con">
              <div class="right" @click="next(item.id,item.fileName,item.isDir, index, item.length)">
                <h3 :title="item.fileName">{{item.fileName}}</h3>
                <span>{{item.gmtModified | formaTime}}</span>
              </div>
              <div class="size">{{item.length | bytesToSize}}</div>
              <div id="more" @click="selected(index)" :class="{'more':up===index}"></div>
            </div>
          </div>
          <div class="select" v-show="select===index">
            <ul class="clearfix">
              <li @click="delAction(item.id,'分享')">
                <i class="iconfont icon-fenxiang tubiao"></i>
                <p>分享</p>
              </li>
              <li v-if="isCanDownload" @click="downLoad('1',item.id,item.isDir,'',item.fileName)">
                <i class="iconfont icon-xiazai tubiao"></i>
                <p>下载</p>
              </li>
              <li @click="delAction(item.id,'删除')">
                <i class="iconfont icon-lajitong tubiao"></i>
                <p>删除</p>
              </li>
              <li @click="delAction(item.id,'更多',index,item.isDir,item.isFavorite,item.fileName)">
                <i class="iconfont icon-gengduodefuben tubiao"></i>
                <p>更多</p>
              </li>
            </ul>
          </div>
        </li>
      </ul>
      <tabbar v-show="!isA" :id="tab"></tabbar>
      <mt-tabbar v-show="isA" :class="{'selected': isA, 'selected-t': opacity, ulcontent: isIphoneX}">
        <mt-tab-item id="分享">
          <i class="iconfont icon-fenxiang tubiao" @click="delActions('分享')"></i>
          <span @click="delActions('分享')">分享</span>
        </mt-tab-item>
        <mt-tab-item id="删除">
          <i class="iconfont icon-lajitong tubiao" @click="delActions('删除')"></i>
          <span @click="delActions('删除')">删除</span>
        </mt-tab-item>
        <mt-tab-item id="移动到">
          <i class="iconfont icon-yidongdao tubiao" @click="delActions('移动到')"></i>
          <span @click="delActions('移动到')">移动到</span>
        </mt-tab-item>
        <mt-tab-item id="下载">
          <i class="iconfont icon-xiazai tubiao" @click="delActions('下载')"></i>
          下载
        </mt-tab-item>
        <mt-tab-item id="复制到">
          <i class="iconfont icon-fuzhidao tubiao" @click="delActions('复制到')"></i>
          <span @click="delActions('复制到')">复制到</span>
        </mt-tab-item>
      </mt-tabbar>
      <!--点击更多-->
      <mt-actionsheet
        :actions="action"
        v-model="sheet">
      </mt-actionsheet>
      <!--具有历史版本的更多-->
      <mt-actionsheet
        :actions="actionh"
        v-model="history">
      </mt-actionsheet>

      <!--分享文件模块-->
      <share v-on:share="listenToShare" :fileId="fileId" v-if="currentValue"></share>
      <div class="v-model" v-if="currentValue" @click="currentValue=false"></div>
    </div>
    <!--复制移动到-->
    <copy v-on:copy="listenToCopy" :fileId="fileId" :model="model" :common="shareFile" v-if="move"
          v-on:move="listenToMove"></copy>

    <!--确认删除-->
    <mt-actionsheet
      :actions="delaction"
      v-model="delVisible" class="del">
    </mt-actionsheet>
    <!--历史版本模块-->
    <history v-on:history="listenToHistory" :fileId="fileId" v-if="fs"></history>

    <mt-popup
      v-model="FileModalshow"
      position="bottom">
      <div class="closeFile">
        <span class="closeBtn" @click="FileModalshow = false">×</span>
      </div>
      <div v-html="FileModalHtml"></div>
    </mt-popup>
    <lightbox :show-light-box="false" :images="imgArray" ref="lightbox"></lightbox>
  </div>
</template>

<script>
  import apis from '@/apis/index'
  import {MessageBox, Toast, Indicator, Popup} from 'mint-ui'
  import cloudApi from '@/apis/cloudStorageApi'
  import Clipboard from 'clipboard'
  import tabbar from '@/components/tabbar.vue'
  import history from '@/components/history.vue'
  import share from '@/components/share.vue'
  import copy from '@/components/copy.vue'
  import {downLoadFile} from '@/components/download.js'
  import Lightbox from 'vue-image-lightbox'
  import $ from 'jquery'
  import Vue from 'vue'
  import fn from '@/components/methods'
  import {eventBus} from '../../utils/event-bus'
  import aaa from '@/components/backAndClose.vue'

  require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

  export default {
    name: 'index',
    components: {
      tabbar,
      downLoadFile,
      Popup,
      Lightbox,
      history,
      share,
      copy,
      aaa
    },
    data () {
      return {
        isIphoneX: false,
        mark: 1, // 1为list， 2 为search
        shareFile: false,
        isSearch: false,
        isClose: false,
        value: '',
        file: '',
        loading: 0,
        loadings: 0,
        FileModalshow: false,
        FileModalHtml: '',
        uploadOptions: {
          singleFile: true,
          testChunks: false,
          uploadMethod: 'POST',
          target: apis.app.cloudStorage.baseUrl + '/api/file/simpleUpload',
          testMethod: 'POST',
          preprocess: this.preprocess,
          withCredentials: true,
          query: {
            guid: '',
            dirId: '',
            size: '',
            type: '',
            name: ''
          }
        },
        attrs: {
          uploadMethod: 'POST',
          accept: '*',
          testMethod: 'POST'
        },
        imgArray: [],
//        确认是否收藏
        isFavorite: 0,
        tab: 1,
        hisFlag: false,
        opacity: true,
        up: '',
//        查看历史版本
//        全选反选数据
        ish: false,
//        其他
        history: false,
        fs: false,
        actionh: [{
          name: '加入收藏',
          method: this.collect
        }, {
          name: '移动到',
          method: this.moveFile
        }, {
          name: '复制到',
          method: this.copy
        }, {
          name: '重命名',
          method: this.rename
        }, {
          name: '查看历史版本',
          method: this.clickFn
        }],
//        当前共享文件夹的id
        sharePid: '',
        shareParentId: [],
        shareFileIds: '',
        shareTarget: true,
        shareIndex: '共享文件',
//        移动成功后重新加载数据的pid
        movePid: '',
//        复制移动
        model: '复制',
//        控制复制移动页面的弹出
        move: false,
//        待复制和移动文件的id
        copyfileId: [],
        copyparam: {
          page: 0,
          size: 20
        },
        copyPage: '',
        copySize: '',
//        点击复制移动时记住之前的页面数据
        copyArr: [],
        copyIndex: '',
        copyParentId: [],
        copyId: '',
//        分享
        currentValue: false,
        shareVisible: false,
//        删除
        delVisible: false,
        delaction: [{
          name: '确认删除',
          method: this.delate
        }],
//        添加
        sheetVisible: false,
//        更多
        sheet: false,
        action: [{
          name: '加入收藏',
          method: this.collect
        }, {
          name: '移动到',
          method: this.moveFile
        }, {
          name: '复制到',
          method: this.copy
        }, {
          name: '重命名',
          method: this.rename
        }],
        select: '',
        flag: false,
//        正在操作的文件索引
        indexing: 0,
        index: '个人文件',
        indexs: '个人文件',
//        存储所有文件的数组
        hello: [],
//        删除文件的id
        delArr: [],
//        需要操作的文件id
        fileId: '',
//        控制全选反选和选择添加的显示隐藏
        isA: false,
//        控制文件被是否被选中
        isB: false,
        message: cloudApi.searchFile,
        pid: 'rootpath',
//        返回上一级文件夹所需id
        parentId: [],
        check: '全选',
        whenId: 'rootpath',
        page: 0,
        size: 20,
        totalPages: '',
        fileName: '',
        inputVlaue: ''
      }
    },
    computed: {
      isCanUpload () {
        return this.$customFunctions.checkPermission('upload')
      },
      isCanDownload () {
        return this.$customFunctions.checkPermission('download')
      }
    },
    created () {
      let isx = this.$store.state.isIphoneX
      this.isIphoneX = isx
      apis.request(cloudApi.show).then(function (res) {
        window.sessionStorage.mobileData = JSON.stringify(res.data)
      })
      eventBus.$on('initFileData', () => {
        apis.request(this.message, {fileId: this.pid, page: 0, size: 20}).then(response => {
          this.hello = response.data.content
        })
      })
      let collect = this.$route.params
      if (collect.length > 0) {
        this.index = collect[collect.length - 1]
        this.indexs = collect[collect.length - 1]
        this.pid = collect[collect.length - 2].pid
        collect.pop()
        collect.pop()
        this.parentId = collect
        this.whenId = this.pid
        apis.request(this.message, {fileId: this.pid, page: 0, size: 20}).then(response => {
          let data = response.data.content
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              this.hello.push(data[i])
            }
          }
          return false
        }).catch(function (error) {
          this.$store.commit('changeId', 'rootpath')
        })
      } else {
        this.$store.commit('changeId', window.localStorage.getItem('pid') || 'rootpath')
        if (window.localStorage.getItem('pid')) {
          this.pid = window.localStorage.getItem('pid')
          this.index = window.localStorage.getItem('index')
          this.indexs = window.localStorage.getItem('index')
          this.parentId = JSON.parse(window.localStorage.getItem('parentId'))
        }
        this.load()
      }
      this.slicetype = Vue.filter('sliceType')
    },
    methods: {
      test () {
        this.$store.dispatch('getPermissionBtns').then(() => {
          if (!this.$customFunctions.checkPermission('upload')) {
            Toast({
              message: '您没有权限进行此操作!',
              duration: 2000,
              iconClass: 'icon-error'
            })
          } else {
            let usedSize = JSON.parse(window.sessionStorage.mobileData).usedSize
            let quota = JSON.parse(window.sessionStorage.mobileData).quota
            if (usedSize < quota) {
              this.sheetVisible = false
              setTimeout(() => {
                $('.uploader-btn').click()
              })
            } else {
              Toast({
                message: '存储空间不足',
                duration: 5000
              })
            }
          }
        })
      },
      uploadNewFile (val, val2, val3) {
        $('.btnuploader-btn').click()
      },
      closeModal: function () {
        this.FileModalshow = false
      },
//      点击查看历史版本
      clickFn: function () {
        this.fs = true
      },
      listenToHistory: function (somedata) {
        this.fs = somedata
      },
      listenToShare: function (somedata) {
        this.currentValue = somedata
      },
      listenToCopy: function (somedata) {
        this.move = somedata
        this.restore()
        this.hello = []
        this.load()
      },
      listenToMove: function (somedata) {
        let _this = this
        _this.move = false
        let deleteArr = somedata.split(',')
        for (let i = 0; i < deleteArr.length; i++) {
          _this.hello.removeByValue(deleteArr[i])
        }
        _this.restore()
        this.hello = []
        this.load()
      },
//      复制到
      copy: function () {
        this.model = '复制 (' + this.copyfileId.length + ')'
        this.move = true
      },
//      移动到
      moveFile: function () {
        this.model = '移动 (' + this.copyfileId.length + ')'
        this.move = true
      },
//      点击返回上一级目录
      back: function () {
        let _this = this
        let length = _this.parentId.length - 1
        let fileId = _this.parentId[length].pid
        _this.whenId = fileId
        apis.request(cloudApi.searchFile, {fileId, page: 0, size: 20}).then(function (res) {
          _this.index = _this.parentId[length].index
          _this.indexs = _this.parentId[length].index
          _this.pid = fileId
          if (!_this.move) {
            window.localStorage.setItem('index', _this.parentId[length].index)
            window.localStorage.setItem('pid', _this.parentId[length].pid)
            _this.parentId.pop()
            let parentArr = JSON.stringify(_this.parentId)
            window.localStorage.setItem('parentId', parentArr)
          } else {
            _this.parentId.pop()
          }
          _this.hello = res.data.content
          if (_this.parentId.length === 0) {
            _this.person = false
            _this.share = false
            _this.kind = false
            _this.shareFileIds = ''
          }
          _this.restore()
        }).catch(function (res) {
        })
      },
//      点击进入下一级目录
      next: function (index, fileName, isDir) {
        let _this = this
        if (isDir === 1) {
          this.whenId = index
          let ulBox = _this.$refs.ulBox
//           搜索框
          _this.isSearch = false
          ulBox.scrollTop = 0
          apis.request(cloudApi.searchFile, {fileId: index, page: 0, size: 20}).then(function (res) {
            _this.hello = []
            ulBox.scrollTop = 0
            if (_this.pid === 'rootpath') {
              _this.parentId = [{pid: 'rootpath', index: '个人文件'}]
            } else {
              _this.parentId.push({pid: _this.pid, index: _this.index})
            }
            _this.pid = index
            _this.index = fileName
            _this.indexs = fileName
            if (!_this.move) {
              window.localStorage.setItem('index', fileName)
              window.localStorage.setItem('pid', index)
              let parentArr = JSON.stringify(_this.parentId)
              window.localStorage.setItem('parentId', parentArr)
            }
            let data = res.data.content
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                _this.hello.push(data[i])
              }
            }
            ulBox.scrollTop = 0
            _this.restore()
          }).catch(function (res) {
          })
        } else {
          this.filePreview(...arguments)
        }
      },
//      点击选择多个文件
      checkMobile: function () {
        this.sheetVisible = false
        this.flag ? this.flag = false : this.flag = true
        this.isA ? this.isA = false : this.isA = true
        this.select = ''
      },
//      单个文件重命名
      rename: function () {
        let _this = this
        fn.rename(_this)
      },
//      单个文件加入收藏
      collect: function () {
        let _this = this
        fn.collect(_this)
      },
//      还原
      restore: function () {
        this.up = ''
        this.opacity = true
        this.select = ''
        this.check = '全选'
        this.isA = false
        this.isB = false
        this.delArr = []
        this.fileId = ''
        this.loading = 0
        this.loadings = 0
        this.flag = false
        this.currentValue = false
        this.page = 0
        this.size = 20
        this.index = window.localStorage.getItem('index')
        let checkbox = this.$refs.mybox
        for (let i = 0; i < checkbox.length; i++) {
          checkbox[i].setAttribute('class', 'check')
        }
      },
//      删除
      delate: function () {
        let _this = this
        fn.del(_this, 1)
      },
//      操作多个文件
      delActions: function (type) {
        let _this = this
        fn.delActions(_this, type)
      },
//      删除单个文件
      delAction: function (itemId, type, index, isDir, isLove, name) {
        this.fileId = itemId
        if (type === '删除') {
          this.delArr = [itemId]
          this.delVisible = true
        } else if (type === '分享') {
          this.currentValue = true
        } else if (type === '更多' && isDir === 1) {
          this.sheet = true
          this.indexing = index
          this.copyfileId = [itemId]
        } else if (type === '更多' && isDir !== 1) {
          this.history = true
          this.indexing = index
          this.copyfileId = [itemId]
        }
        this.isFavorite = isLove
        this.fileName = name
      },
//      下拉操作
      selected: function (index) {
        if (this.select === index) {
          this.select = ''
          this.up = ''
        } else {
          this.select = index
          this.up = index
        }
      },
//      新建文件夹
      prompt: function () {
        let _this = this
        _this.sheetVisible = false
        fn.prompt(_this, '个人文件')
      },
//      单个文件选中
      checked: function (index) {
        let length = this.hello.length
        let _this = this
        let num = this.$refs.mybox[index].className.indexOf('checked')
        let checkbox = this.$refs.mybox
        let flag = 0
        if (num === -1) {
          let className = this.$refs.mybox[index].getAttribute('class')
          checkbox[index].setAttribute('class', className + ' ' + 'checked')
          for (let i = 0; i < checkbox.length; i++) {
            if (checkbox[i].className.indexOf('checked') !== -1) {
              flag++
            }
          }
          if (flag > 0) {
            _this.index = `已选择${flag}个文件`
            _this.opacity = false
          }
          if (flag === length) {
            _this.check = '取消全选'
            // _this.isB = true
          }
        } else {
          _this.opacity = true
          checkbox[index].setAttribute('class', 'check')
          for (let i = 0; i < checkbox.length; i++) {
            if (checkbox[i].className.indexOf('checked') !== -1) {
              flag++
            }
          }
          if (flag > 0) {
            _this.index = `已选择${flag}个文件`
            _this.check = '全选'
            _this.opacity = false
          } else {
            _this.index = _this.indexs
          }
          if (flag === 0) {
            if (_this.check === '取消全选') {
              _this.checkAll()
            }
          }
        }
      },
//      全选
      checkAll: function () {
        let _this = this
        if (_this.hello.length === 0) {
          return false
        }
        if (_this.check === '全选') {
          let checkboxs = _this.$refs.mybox
          for (let i = 0; i < checkboxs.length; i++) {
            checkboxs[i].setAttribute('class', 'check checked')
          }
          // _this.isB = true
          this.check = '取消全选'
          this.opacity = false
          let checkbox = this.$refs.mybox.length
          _this.index = `已选择${checkbox}个文件`
          let box = this.$refs.mybox
          var arr = ''
          for (let i = 0; i < box.length; i++) {
            arr += box[i].getAttribute('fileId') + ','
          }
          arr = arr.substring(0, arr.length - 1)
          _this.delArr = arr.split(',')
          _this.fileId = arr
        } else {
          // this.isB = false
          this.check = '全选'
          this.opacity = true
          _this.index = _this.indexs
          let checkbox = this.$refs.mybox
          for (let i = 0; i < checkbox.length; i++) {
            checkbox[i].setAttribute('class', 'check')
          }
        }
      },
//      取消选中状态
      cancel: function () {
        this.index = this.indexs
        this.check = '全选'
        this.isB = false
        this.fileId = ''
        this.select = ''
        this.up = ''
        this.opacity = true
        this.isA ? this.isA = false : this.isA = true
        let checkbox = this.$refs.mybox
        for (let i = 0; i < checkbox.length; i++) {
          checkbox[i].setAttribute('class', 'check')
        }
      },
      load: function () {
        this.page = 0
        apis.request(this.message, {fileId: this.pid, page: 0, size: 20}).then(response => {
          let data = response.data.content
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              this.hello.push(data[i])
            }
            this.totalPages = response.data.totalPages
          } else {
            this.hello = []
          }
          return false
        }).catch(function (error) {
        })
      },
      // 加载更多
      loadMore () {
        let _this = this
        if (this.mark === 1) {
          if (this.page < this.totalPages && _this.loading === 0) {
            _this.loading = 1
            this.page++
          } else {
            return
          }
          setTimeout(() => {
            let _this = this
            apis.request(_this.message, {fileId: _this.pid, page: _this.page, size: _this.size}).then(function (res) {
              let list0 = []
              let data = res.data.content
              if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                  list0.push(data[i])
                }
                if (_this.hello && list0) {
                  _this.hello = _this.hello.concat(list0)
                }
                _this.loading = 0
                _this.check = '全选'
              }
            })
          }, 250)
        } else {
          if ((_this.page < _this.totalPages) && (_this.loadings === 0)) {
            this.page++
            _this.loadings = 1
          } else {
            return
          }
          setTimeout(() => {
            let _this = this
            apis.request(cloudApi.fileSearch, {key: _this.value, page: _this.page, size: _this.size}).then(function (res) {
              let list0 = []
              let data = res.data.content
              if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                  list0.push(data[i])
                }
                if (_this.hello && list0) {
                  _this.hello = _this.hello.concat(list0)
                }
              }
              _this.loadings = 0
            })
          }, 250)
        }
      },
      // 文件预览
      filePreview: function () {
        var _this = this
        this.$store.dispatch('getPermissionBtns').then(() => {
          if (!this.$customFunctions.checkPermission('preview')) {
            Toast({
              message: '您没有权限进行此操作!',
              duration: 2000,
              iconClass: 'icon-error'
            })
          } else {
            this.imgArray = []
            var sliceType = Vue.filter('sliceType')
            for (var i = 0; i < _this.hello.length; i++) {
              if (sliceType(_this.hello[i].fileName) === 'icon-pic') {
                _this.hello[i].thumb = apis.app.cloudStorage.baseUrl + cloudApi.unifileD.path + '?fileId=' + _this.hello[i].id + '&type=2'
                _this.hello[i].src = apis.app.cloudStorage.baseUrl + cloudApi.unifileD.path + '?fileId=' + _this.hello[i].id + '&type=2'
                var obj = JSON.parse(JSON.stringify(_this.hello[i]))
                _this.imgArray.push(obj)
              }
            }
            if (sliceType(arguments[1]) === 'icon-pic') {
              let idx = ''
              _this.imgArray.forEach((value, index) => {
                if (value.fileName === arguments[1]) {
                  idx = index
                }
              })
              this.$refs.lightbox.showImage(idx)
            } else {
              let list = ['txt', 'doc', 'docx', 'xlsx', 'xls', 'pdf', 'wps', 'wpt', 'xls', 'pptx', 'ppt']
              let fileType = arguments[1].lastIndexOf('.')
              let type = arguments[1].substring(fileType + 1).trim()
              if (list.indexOf(type) !== -1) {
                var uSized = arguments[4] / 1024 / 1024
                if (uSized < 10) {
                  Indicator.open('加载中...')
                  apis.request(cloudApi.preview, {fileId: arguments[0]}).then(function (response) {
                    if (!response.data.code) {
                      Indicator.close()
                      _this.FileModalHtml = response.data.text
                      _this.FileModalshow = true
                    } else {
                      Indicator.close()
                      Toast({
                        message: '文件正在预览处理中,请稍后再试！',
                    // position: 'bottom',
                        duration: 5000
                      })
                    }
                  }).catch(function (error) {
                    Indicator.close()
                    Toast({
                      message: '预览文件失败,请稍后重试',
                      position: 'bottom',
                      duration: 5000
                    })
                  })
                } else {
                  Toast({
                    message: '您预览文件较大,请下载后预览',
                    duration: 5000
                  })
                }
              } else {
                Toast({
                  message: '当前文件格式暂不支持预览',
                  iconClass: 'icon-error'
                })
              }
            }
          }
        })
      },
      downLoad: function () {
        Toast('文件正在下载...')
        downLoadFile(...arguments)
      },
      search () {
        this.isSearch = true
      },
      focusInput () {
        this.isClose = true
      },
      blurInput () {
        if (this.value !== '') {
          this.isClose = true
        } else {
          this.isClose = false
        }
      },
      clear () {
        if (this.value !== '') {
          this.value = ''
          this.load()
          this.hello = []
          this.restore()
        }
      },
      cancelSearch () {
        this.isSearch = false
        this.value = ''
        this.mark = 1
        this.load()
        this.restore()
        this.hello = []
      },
      serchContent () {
        var _this = this
        if (_this.value !== '') {
          _this.mark = 2
          _this.page = 0
          _this.hello = []
          apis.request(cloudApi.fileSearch, {
            key: _this.value,
            page: _this.page,
            size: _this.size
          }).then(function (res) {
            let data = res.data.content
            _this.totalPages = res.data.totalPages
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                if (data[i].fileName.length > _this.maxLen) {
                  data[i].fileName = data[i].fileName.substring(0, _this.maxLen) + '...'
                }
                _this.hello.push(data[i])
              }
            } else {
              _this.$refs.dis.innerText = '未搜索到相关文件/文件夹'
            }
          })
          _this.restore()
        } else {
          _this.mark = 1
          _this.hello = []
          _this.load()
        }
      }
    },
    watch: {
      whenId: function (val) {
        this.$store.commit('changeId', val)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .iconfont {
    font-size: 0.62rem;
  }

  html
  .closeFile {
    position: absolute;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    height: 50px;
    z-index: 9999;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .closeBtn {
    cursor: pointer;
    color: #e5e6eb;
    margin-right: 10px;
    font-size: 30px;
    -webkit-transition: color 0.4s ease-in-out;
    transition: color 0.4s ease-in-out;
    text-decoration: none;
    text-align: center;
    position: absolute;
    right: 0px;
  }

  .mint-popup {
    width: 100%;
    z-index: 2001;
    height: 100%;
    overflow: auto;
  }

  .icon-success {
    background: url("../../assets/images/success_icon.png");
  }

  body {
    font-size: 0.16rem !important;
  }

  [v-cloak] {
    display: none;
  }

  .hello {
    height: 100%;
    padding-top: 1.28rem;
    padding-bottom: 0.98rem;
  }

  #title {
    width: 50%;
    margin: 0 auto;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    display: inline-block;
  }

  input {
    font-size: 0.16rem;
  }

  input:focus {
    outline: none;
  }

  .check-mobile {
    background: url("../../assets/images/check-mobile.png") center no-repeat;
    background-size: 0.36rem 0.36rem;
  }

  .open-mobile {
    background: url("../../assets/images/open-mobile.png") center no-repeat;
    background-size: 0.36rem 0.36rem;
  }

  .right h3 {
    /*height: 0.4rem;*/
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    /*white-space: nowrap;*/
    word-break: break-all;
    font-size: 0.28rem;
    color: #1d1f22;
  }

  .right span {
    font-size: 0.2rem;
    color: #9b9b9b;
    vertical-align: middle;
  }

  h1, h2, h3 {
    font-weight: normal;
    margin: 0;
    line-height: initial;
  }

  h3 {
    text-align: left;
  }

  /*顶部样式*/
  .head {
    font-size: 0.36rem !important;
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.28rem;
    line-height: 0.88rem;
    -webkit-backdrop-filter: blur(40px);
    backdrop-filter: blur(40px);
    color: #fff;
    z-index: 999;
  }

  .head ul {
    text-align: center;
    position: relative;
    margin-top: 0.4rem;
  }

  #head ul li:nth-of-type(n+2) {
    float: right;
    width: 0.36rem;
    height: 0.36rem;
    position: absolute;
    right: 0;
    top: 0.25rem;
  }

  #head ul li:last-of-type {
    right: 0.66rem;
  }

  /*无内容时样式*/
  .jpg {
    position: relative;
    height: 100%;
  }

  .jpg div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .jpg div p {
    font-size: 0.28rem;
    color: #41464c;
  }

  /*有内容时的样式*/
  .ulBox {
    height: 100%;
    overflow-y: scroll;
    background-color: #fff;
    padding-bottom: .86rem;
  }

  .list {
    padding-left: 0.3rem;
    width: 80%;
  }

  /*点击下啦*/
  .select {
    height: 0.98rem;
    background-color: #f7f7fa;
  }

  .tubiao {
    font-size: .48rem;
    display: block;
    color: #999999
  }

  .select ul {
    display: flex;
    justify-content: space-around;
    height: 100%;
    padding: .1rem 0;
    color: #333333;
    background-color: #f7f7f7;
    font-size: 0.2rem;
  }

  .select ul li {
    float: left;
    height: 100%;
    width: 25%;
    border: none;
    text-align: center;
  }

  .select ul li img {
    float: initial;
    width: 0.35rem;
    height: 0.36rem;
  }

  .btn {
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    color: #fff;
  }

  .con {
    display: inline-block;
    width: 70%;
    margin-left: 0.228rem;
  }

  .con .size {
    position: absolute;
    right: 0.64rem;
    top: 0.4rem;
    color: #c7c7c7;
  }

  .icon-default {
    color: #dadcdd;
  }

  #more {
    width: 0.2rem;
    height: 0.26rem;
    position: absolute;
    right: 0.2rem;
    top: 0.4rem;
    background: url("../../assets/images/down.png") center no-repeat;
    background-size: 0.18rem 0.12rem;
  }

  .more {
    background: url("../../assets/images/up.png") center no-repeat !important;
    background-size: 0.18rem 0.12rem !important;
  }

  .ulBox li {
    border-top: 1px solid #e5e5e5;
    text-align: left;
    position: relative;
  }

  .ulBox > li:last-of-type {
    border-bottom: 1px solid #e5e5e5;
  }

  .ulBox li:first-child #moreh {
    display: none;
  }

  .ulBox li div:first-of-type {
    box-sizing: border-box;
  }

  .ulBox .list {
    /*height: 0.99rem;*/
    display: flex;
    padding-top: 0.14rem;
  }

  .ulBox li img {
    float: left;
    width: 0.5rem;
    height: 0.5rem;
    display: inline-block;
  }

  .check {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    margin-bottom: 0.12rem;
    margin-right: 0.3rem;
  }

  .checked {
    background: url('../../assets/images/success_big.png') center no-repeat;
    background-size: 0.24rem 0.24rem;
    border: none;
  }

  /*分享样式*/
  .v-model {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
    z-index: 2000;
  }

  @keyframes move {
    from {
      top: 800px;
    }
    to {
      top: 0;
    }
  }

  .move {
    animation: move 5s;
  }

  .copyhello {
    padding-top: 1.88rem;
    padding-bottom: .97rem;
  }

  .tip {
    height: 0.6rem;
    line-height: 0.6rem;
    background-color: #f7f7fa;
    color: #666;
    font-size: 0.24rem;
    padding-left: 0.3rem;
  }

  #cancel {
    position: absolute;
    right: 0.3rem;
    font-size: 0.28rem;
  }

  .pb {
    padding-bottom: 0;
  }

  .bp {
    padding-bottom: 0.98rem;
  }

  .shareTarget {
    opacity: 0.6;
  }

  #check-history {
    width: 0.36rem;
    height: 0.36rem;
    position: absolute;
    right: 0;
    top: 0.25rem;
  }

  #his {
    background-color: #3f4b5f;
    line-height: 0.98rem;
    color: #fff;
  }

  #his a {
    opacity: 0.3;
  }

  #his .box {
    opacity: 0.3;
    color: #fff;
  }

  .his a {
    opacity: 1 !important;
  }

  #his .box img {
    width: 0.34rem;
    height: 0.36rem;
  }

  .begin .head ul input {
    height: 0.4rem;
    font-size: 0.28rem;
    margin-top: 0.23rem;
    width: 1.12rem;
    text-align: right;
  }

  .begin .head ul input:first-of-type {
    text-align: left;
  }

  .begin .head {
    padding: 0 0.3rem;
  }

  .back {
    width: 0.2rem;
    height: 0.35rem;
    background: url("../../assets/images/back-mobile.png") center no-repeat;
    background-size: 0.2rem 0.35rem;
    top: 0.26rem;
    position: absolute;
    left: 0;
  }

  #selectDown {
    display: flex;
    justify-content: space-around;
    top: 0;
    height: 1.42rem;
    position: fixed;
    width: 100%;
    text-align: center;
    left: 0;
    backface-visibility: hidden;
    transform: translate3d(0px, 0px, 0px);
    transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;
    background-color: #fff;
    padding: 0.18rem 0 0.24rem 0;
    z-index: 2001;
  }

  #selectDown div {
    width: 50%;
    float: left;
    color: #1d1f22 !important;
    text-align: center;
    font-size: 0.24rem;
    height: 100%;
    line-height: initial;
  }

  #selectDown div input {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }

  #selectDown div img {
    display: block;
    margin: 0 auto;
    width: 0.48rem;
    height: 0.4rem;
    margin-bottom: 0.1rem;
  }

  .pullUp {
    transform: translate3d(0px, 1.28rem, 0px) !important;
  }

  .history .right {
    position: relative;
  }

  i {
    font-style: normal;
  }

  .search {
    display: block;
    padding: .15rem .15rem;
    position: relative;
  }

  .search input {
    width: 100%;
    border: 1px solid #e6e6ea;
    height: .56rem;
    border-radius: 0.1rem;
    color: #B2B2B2;
    text-align: center;
    font-size: .26rem;
  }

  .search i {
    position: absolute;
    font-size: .3rem;
    color: #B2B2B2;
    left: 42%;
    top: .3rem;
  }

  /* 搜索样式*/
  #search {
    height: 1.28rem;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    padding: .57rem .16rem .15rem .16rem;
    form {
      height: .56rem;
      line-height: .56rem;
    }
    input {
      height: .56rem;
      /*width: 6.34rem;*/
      width: 5.8rem;
      padding-left: .51rem;
      border-radius: 10px;
      font-size: .26rem;
      color: #444;
    }
    input::-webkit-input-placeholder {
      color: #999;
    }
    .sousuo {
      position: absolute;
      left: .32rem;
      color: #b2b2b2;
      font-size: 0.26rem;
    }
    .guangbi {
      font-size: .3rem;
      position: absolute;
      color: #778392;
      /*right: 1.1rem;*/
      right: 1.64rem;
    }
    span {
      font-size: .32rem;
      display: inline-block;
      float: right;
      color: #fff;
    }
    .search-list {
      font-size: .45rem;
      margin-right: .1rem;
    }
  }
</style>
<style lang="scss">
  .uploader {
    border: none !important;
    float: none !important;
    margin: 0 auto;
  }

  #app .uploader-btn {
    padding: none;
    background: none;
    outline: none;
    border: none;
  }

  .v-model {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
  }

  .mint-popup .head {
    height: .88rem;
  }

  .mint-popup .back {
    margin-left: 0.2rem;
  }

  .head {
    text-align: center;
  }

  #fileModal {
    margin-top: .88rem;
    overflow: auto;
    height: 100%;
  }

  .shareDir1 {
    color: #47A3FB;
  }
  .ulcontent {
    padding-bottom: 1.55rem!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue